(function () {
  function initRow(row) {
    var strip = row.querySelector('[data-featured-collection-strip]');
    var nav = row.querySelector('[data-featured-collection-nav]');
    if (!strip || !nav) return;

    function updateNavState() {
      var maxScroll = strip.scrollWidth - strip.clientWidth;
      var tol = 2;
      nav.querySelectorAll('[data-scroll-dir]').forEach(function (btn) {
        var dir = btn.getAttribute('data-scroll-dir');
        if (dir === 'prev') {
          btn.disabled = strip.scrollLeft <= tol;
        } else {
          btn.disabled = strip.scrollLeft >= maxScroll - tol;
        }
      });
      if (maxScroll <= tol) {
        nav.setAttribute('hidden', '');
      } else {
        nav.removeAttribute('hidden');
      }
    }

    nav.querySelectorAll('[data-scroll-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-scroll-dir');
        var amount = Math.max(strip.clientWidth * 0.75, 240);
        strip.scrollBy({
          left: dir === 'next' ? amount : -amount,
          behavior: 'smooth',
        });
      });
    });

    strip.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateNavState);
    });
    strip.addEventListener(
      'load',
      function (e) {
        if (e.target.tagName === 'IMG') {
          window.requestAnimationFrame(updateNavState);
        }
      },
      true
    );
    window.addEventListener(
      'resize',
      function () {
        window.requestAnimationFrame(updateNavState);
      },
      { passive: true }
    );
    updateNavState();
  }

  document.querySelectorAll('[data-featured-collection-row]').forEach(initRow);
})();
